export default __webpack_public_path__ + "static/media/sertifikat_keanggotaan_new.e971d2f1.png";